import {
	EVENT_ACTION_PARKING_PAYMENT_ADD_NEW,
	EVENT_ACTION_PARKING_PAYMENT_REMEMBER_CARD,
	EVENT_CATEGORY_PARKING_PAYMENT,
	trackCustomEvent,
} from '../../../../../../shared/analytics';
import { INewCardFormData } from '../../../payment/types/INewCardFormData';

export function trackPaymentSubmitNewCard(data: INewCardFormData) {
	trackCustomEvent({
		category: EVENT_CATEGORY_PARKING_PAYMENT,
		action: EVENT_ACTION_PARKING_PAYMENT_ADD_NEW,
	});

	if (data.saveCreditCard) {
		trackCustomEvent({
			category: EVENT_CATEGORY_PARKING_PAYMENT,
			action: EVENT_ACTION_PARKING_PAYMENT_REMEMBER_CARD,
		});
	}
}
